import { NavLink, useLocation } from "react-router-dom";
import { Home, Users, MessageSquare, ClipboardList, UserRound } from "lucide-react";

const TABS = [
  { to: "/", label: "Home", icon: Home, testid: "tab-home", exact: true },
  { to: "/directory", label: "Team", icon: Users, testid: "tab-team" },
  { to: "/messages", label: "Chat", icon: MessageSquare, testid: "tab-chat" },
  { to: "/onboarding", label: "Journey", icon: ClipboardList, testid: "tab-journey" },
  { to: "/profile", label: "Me", icon: UserRound, testid: "tab-me" },
];

export default function BottomTabBar() {
  const { pathname } = useLocation();
  return (
    <nav className="bottom-tab-bar" data-testid="bottom-tab-bar" aria-label="Primary">
      {TABS.map((t) => {
        const Icon = t.icon;
        const active = t.exact ? pathname === t.to : pathname === t.to || pathname.startsWith(`${t.to}/`);
        return (
          <NavLink
            key={t.to}
            to={t.to}
            data-testid={t.testid}
            data-active={active}
            className={`tab-item ${active ? "active" : ""}`}
          >
            <Icon size={20} strokeWidth={active ? 2.4 : 2} />
            <span>{t.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
